import { render } from "./register-stepper-result.vue?vue&type=template&id=011006c2&scoped=true&ts=true"
import script from "./register-stepper-result.vue?vue&type=script&lang=ts"
export * from "./register-stepper-result.vue?vue&type=script&lang=ts"

import "./register-stepper-result.vue?vue&type=style&index=0&id=011006c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011006c2"]])

export default __exports__